<template>
  <div class="entitydropdown form-group">
    <CAlert show color="danger" v-if="hasError">A problem occured: {{ hasError }}</CAlert>
    <label class="entitydropdown-label">Link</label>
    <input
      v-model.trim="search"
      @focus="searchHasFocus = true"
      @blur="searchHasFocus = false"
      class="entitydropdown-input"
      type="text"
      :placeholder="placeholder"
    />
    <div class="entitydropdown-container">
      <div v-show="search && loaded" class="entitydropdown-list">
        <div v-for="item in items" :key="item.id" @click="selectItem(item)" class="entitydropdown-item">
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
const limit = 10

export default {
  name: 'EntityDropdown',
  props: {
    entityType: { type: String, default: 'screen' },
    selectedId: { type: Number },
  },
  data() {
    return {
      items: [],
      search: '',
      loaded: false,
      selectedItem: {},
      selectedTitle: '',
      searchHasFocus: false,
      hasError: false,
    }
  },
  watch: {
    selectedId: {
      handler() {
        this.getSelectedData()
      },
    },
    search: {
      handler() {
        this.triggerSearch()
      },
    },
  },
  computed: {
    placeholder() {
      if (this.selectedId && !this.searchHasFocus) {
        return `${this.selectedId}: ${this.selectedTitle}`
      } else if (this.entityType) {
        return `Type to search for a ${this.entityType}`
      }
      return 'Select entity type first'
    },
    label() {
      if (this.selectedItem.id) {
        return `${this.selectedItem.id}: ${this.selectedItem.title}`
      } else if (this.selectedId) {
        return `${this.selectedId}: ${this.selectedTitle}`
      }
      return 'Link to screen, block etc.'
    },
  },
  methods: {
    selectItem(item) {
      this.selectedItem = item
      this.search = ''
      this.$emit('on-item-selected', item)
    },

    triggerSearch: _.debounce(function() {
      if (!this.entityType) return
      this.getData()
      this.loaded = false
    }, 500),

    getSelectedData() {
      this.$api
        .get(`${this.entityType}/${this.selectedId}`)
        .then(response => {
          const { data } = response

          switch (this.entityType) {
            case 'screen':
              this.selectedTitle = data.screen.label
              break
            case 'block':
              this.selectedTitle = data.name
              break
            case 'podcast':
              this.selectedTitle = data.podcast_info.title
              break
            default:
              this.selectedTitle = data.title
              break
          }
        })
        .catch(error => (this.hasError = error))
    },

    getData() {
      let path = '';
      if (this.entityType === 'playlist') {
        this.items = this.$settings.playlists
        this.loaded = true
      } else {
        path = `${this.entityType}s/`
        this.$api
            .get(`${path}?q=${this.search}&limit=${limit}`)
            .then(response => {
              this.parseData(response.data)
              this.loaded = true
            })
            .catch(error => (this.hasError = error))
      }
    },

    parseData(data) {
      switch (this.entityType) {
        case 'screen':
          data.map(scr => (scr.title = scr.label))
          this.items = data
          break
        case 'block':
          data.map(bl => (bl.title = bl.name))
          this.items = data
          break
        case 'podcast':
          this.items = data.podcasts
          break
        case 'episode':
          this.items = data.episodes
          break
        default:
          break
      }
    },
  },
}
</script>

<style>
.entitydropdown {
  position: relative;
  width: 100%;
  margin: 0;
  z-index: 100;
}
.entitydropdown-label {
  white-space: nowrap;
  display: block;
  overflow-x: hidden;
}
.entitydropdown-input {
  color: #768192;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border: 1px solid #d8dbe0;
  background: #fff;
  line-height: 1.5;
  border-radius: 0.25rem;
  background-clip: padding-box;
  outline: none;
}
.entitydropdown-input:focus {
  background: #fff;
  border-color: #958bef;
  box-shadow: 0 0 0 0.2rem rgba(50, 31, 219, 0.25);
  outline: 0;
}
.entitydropdown-input::placeholder {
  color: #768192;
  opacity: 0.8;
}
.entitydropdown-container {
  position: relative;
}
.entitydropdown-list {
  position: absolute;
  width: 100%;
  max-height: 500px;
  margin-top: 0.375rem;
  overflow-y: auto;
  background: #efefef;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.2), 0 4px 6px -2px rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
}
.entitydropdown-item {
  display: flex;
  width: 100%;
  padding: 0.375rem 0.75rem;
  cursor: pointer;
  border-bottom: 1px solid #d8dbe0;
}
.entitydropdown-item:last-child {
  border-bottom: none;
}
.entitydropdown-item:hover {
  background: #888;
  color: #fff;
}
</style>
